import { IconsWrapper } from "@core";

export class MonoprixIconsWrapper extends IconsWrapper {
  constructor() {
    const overridedIcons = [
      [
        "Trash",
        "https://storage.googleapis.com/assets.miam.tech/monoprix/icons/Trash.svg",
      ],
      [
        "Minus",
        "https://storage.googleapis.com/assets.miam.tech/monoprix/icons/Minus.svg",
      ],
      [
        "Plus",
        "https://storage.googleapis.com/assets.miam.tech/monoprix/icons/Plus.svg",
      ],
      [
        "CheckCircleFill",
        "https://storage.googleapis.com/assets.miam.tech/monoprix/icons/CheckCircleFill.svg",
      ],
      [
        "Hot",
        "https://storage.googleapis.com/assets.miam.tech/monoprix/icons/Cooking.svg",
      ],
      [
        "Cart",
        "https://storage.googleapis.com/assets.miam.tech/monoprix/icons/Cart.svg",
      ],
    ];
    super(overridedIcons);
  }
}
